import type { QueryClient } from '@tanstack/react-query';

export const queryClientConfig: ConstructorParameters<typeof QueryClient>[0] = {
  defaultOptions: {
    queries: {
      staleTime: 1200000,
      cacheTime: Infinity,
      refetchOnWindowFocus: false,
      refetchOnMount: false,
      refetchOnReconnect: true,
      retry: 3,
      suspense: true,
    },
  },
};
